var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeutraUserImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "neutraUserImg",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(0 0)",
    fill: "rgba(255,167,0,0.2)",
    stroke: "#ffa700",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(7.809 6.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M17.125,29.5H16.7c-1.313,0-3.2.885-3.2,2.369a.7.7,0,0,0,.656.771h5.537a.687.687,0,0,0,.656-.742v-.029C20.35,30.385,18.467,29.5,17.125,29.5Z",
    transform: "translate(-13.5 -24.077)",
    fill: "var(--bgColor)",
    stroke: "#ffa700",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M20.5,15.352a1.616,1.616,0,0,0,1.227-.514A3.633,3.633,0,0,0,22.5,12.5a2,2,0,1,0-4,0,3.737,3.737,0,0,0,.771,2.369A1.7,1.7,0,0,0,20.5,15.352Z",
    transform: "translate(-17.073 -10.5)",
    fill: "var(--bgColor)",
    stroke: "#ffa700",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutraUserImg);
export default __webpack_public_path__ + "static/media/neutraUserImg.33bf5b749e0bb21bd22037b2b4487da0.svg";
export { ForwardRef as ReactComponent };